import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=0f8531d8&scoped=true"
import script from "./Outro.vue?vue&type=script&lang=js"
export * from "./Outro.vue?vue&type=script&lang=js"
import style0 from "./Outro.vue?vue&type=style&index=0&id=0f8531d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8531d8",
  null
  
)

export default component.exports